export default "__VITE_ASSET__CvEAwjmm__"